module.exports = __webpack_public_path__ + "img/news-1.f8c422ca.png";